<template>
  <main v-if="$page">
    <HomeHeader :content="$page.header" :link="$page.header_link" :page="$page.header_page" />
    <CTASection
      :content="$page.vision"
      :link="$page.vision_link"
      :page="$page.vision_page"
      class="--dark"
    />
    <SplitSection :content="familyOffice" class="--light" />
    <ImageCTASection
      :content="$page.services"
      :link="$page.services_link"
      :page="$page.services_page"
    />
    <ImageCTASection
      :content="$page.perks"
      :link="$page.perks_link"
      :page="$page.perks_page"
      reverse
    />
    <CTASection
      :content="$page.jobs"
      :link="$page.jobs_link"
      :page="$page.jobs_page"
      class="--light"
    />
  </main>
</template>

<script>
import family_logo from '@/assets/images/dvfo_logo_en.svg'
import family_image from '@/assets/images/family.jpg'
import CTASection from '@/components/sections/CTASection.vue'
import HomeHeader from '@/components/sections/HomeHeader.vue'
import ImageCTASection from '@/components/sections/ImageCTASection.vue'
import SplitSection from '@/components/sections/SplitSection.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin.js'

export default {
  name: 'Home',
  beetPage: 'home',
  mixins: [PageMetaMixin],
  components: { CTASection, HomeHeader, ImageCTASection, SplitSection },
  computed: {
    familyOffice() {
      return {
        action: () => this.$store.dispatch('openFamilyOffice'),
        button: this.$t('family.cta'),
        description: this.$t('family.text'),
        image: family_image,
        logo: family_logo,
        title: this.$t('family.title'),
      }
    },
  },
  watch: {
    '$route.query.video': {
      handler(value) {
        if (value) {
          this.tryVideo()
          this.$router.replace({ name: 'home' })
        }
      },
      immediate: true,
    },
    $page: {
      handler() {
        this.tryVideo()
      },
      immediate: true,
    },
  },
  methods: {
    tryVideo() {
      if (this.$page && this.$route.query.video) {
        this.$store.dispatch('openModalVideo', this.$page.header.video)
      }
    },
  },
}
</script>
